import _createClass from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/** Class representing a PayViewData */
var PayViewData = /*#__PURE__*/_createClass(
/**
 * Create a PayViewData
 * @property {string} employeeId
 * @property {string} employeeName
 * @property {PayPeriodData[]} employeePayPeriods
 * @property {TeamMemberPayData[]} teamMemberPayData
 */
function PayViewData() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var employeeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var employeePayPeriods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var teamMemberPayData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, PayViewData);
  /** @type {string} */
  this.employeeId = employeeId;
  /** @type {string} */
  this.employeeName = employeeName;
  /** @type {PayPeriodData[]} */
  this.employeePayPeriods = employeePayPeriods;
  /** @type {TeamMemberPayData[]} */
  this.teamMemberPayData = teamMemberPayData;
});
/** Class representing a TeamMemberPayData */
var TeamMemberPayData = /*#__PURE__*/_createClass(
/**
 * Create a TeamMemberPayData
 * @param {string} employeeId
 * @param {string} name
 * @param {PayPeriodData[]} payPeriods
 */
function TeamMemberPayData() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var payPeriods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  _classCallCheck(this, TeamMemberPayData);
  /** @type {string} */
  this.employeeId = employeeId;
  /** @type {string} */
  this.name = name;
  /** @type {PayPeriodData[]} */
  this.payPeriods = payPeriods;
});
/** Class representing a PayPeriodData */
var PayPeriodData = /*#__PURE__*/_createClass(
/**
 * Create a PayPeriodData
 * @param {PayPeriod} payPeriod
 * @param {string} source
 * @param {EarningsData} earnings
 * @param {PerformanceCategory[]} performance
 */
function PayPeriodData() {
  var payPeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriod();
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var earnings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new EarningsData();
  var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, PayPeriodData);
  /** @type {PayPeriod} */
  this.payPeriod = payPeriod;
  /** @type {string} */
  this.source = source;
  /** @type {EarningsData} */
  this.earnings = earnings;
  /** @type {PerformanceCategory[]} */
  this.performance = performance;
});
/** Class representing a PayPeriod */
var PayPeriod = /*#__PURE__*/_createClass(
/**
 * Create a PayPeriod
 * @param {string} startDate
 * @param {string} endDate
 */
function PayPeriod() {
  var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, PayPeriod);
  /** @type {string} */
  this.startDate = startDate;
  /** @type {string} */
  this.endDate = endDate;
});
/** Class representing an EarningsData */
var EarningsData = /*#__PURE__*/_createClass(
/**
 * Create an EarningsData
 * @param {number} totalEarnings
 * @param {number} totalSales
 * @param {number} totalSessions
 * @param {EarningsCategory[]} earningsCategories
 */
function EarningsData() {
  var totalEarnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var totalSales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var totalSessions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var earningsCategories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, EarningsData);
  /** @type {number} */
  this.totalEarnings = totalEarnings;
  /** @type {number} */
  this.totalSales = totalSales;
  /** @type {number} */
  this.totalSessions = totalSessions;
  /** @type {EarningsCategory[]} */
  this.earningsCategories = earningsCategories;
});
/** Class representing an EarningsCategory */
var EarningsCategory = /*#__PURE__*/_createClass(
/**
 * Create an EarningsCategory
 * @param {string} title
 * @param {number} categoryTotal
 * @param {MetricEarningsData[]} metrics
 */
function EarningsCategory() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var categoryTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var metrics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  _classCallCheck(this, EarningsCategory);
  /** @type {string} */
  this.title = title;
  /** @type {number} */
  this.categoryTotal = categoryTotal;
  /** @type {MetricEarningsData[]} */
  this.metrics = metrics;
});
/** Class representing a MetricEarningsData */
var MetricEarningsData = /*#__PURE__*/_createClass(
/**
 * Create a MetricEarningsData
 * @param {string} metricName
 * @param {number} metricQuantity
 * @param {number} metricAmountPer
 * @param {number} metricTotalEarnings
 */
function MetricEarningsData() {
  var metricName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var metricAmountPer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var metricTotalEarnings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  _classCallCheck(this, MetricEarningsData);
  /** @type {string} */
  this.metricName = metricName;
  /** @type {number} */
  this.metricQuantity = metricQuantity;
  /** @type {number} */
  this.metricAmountPer = metricAmountPer;
  /** @type {number} */
  this.metricTotalEarnings = metricTotalEarnings;
});
/** Class representing a PerformanceCategory */
var PerformanceCategory = /*#__PURE__*/_createClass(
/**
 * Create a PerformanceCategory
 * @param {string} name
 * @param {number} categoryTotalQuantity
 * @param {string} categoryTotalUnitType
 * @param {PerformanceMetric[]} metrics
 */
function PerformanceCategory() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var categoryTotalQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var categoryTotalUnitType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var metrics = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, PerformanceCategory);
  /** @type {string} */
  this.name = name;
  /** @type {number} */
  this.categoryTotalQuantity = categoryTotalQuantity;
  /** @type {string} */
  this.categoryTotalUnitType = categoryTotalUnitType;
  /** @type {PerformanceMetric[]} */
  this.metrics = metrics;
});
/** Class representing a PerformanceMetric */
var PerformanceMetric = /*#__PURE__*/_createClass(
/**
 * Create a PerformanceMetric
 * @param {string} metricName
 * @param {number} metricValue
 * @param {number} metricQuantity
 * @param {string} unitType
 * @param {number} payTotal
 * @param {number} absoluteMin
 * @param {number} absoluteMax
 * @param {Tier[]} tiers
 */
function PerformanceMetric() {
  var metricName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var metricQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var unitType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var payTotal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var absoluteMin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var absoluteMax = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var tiers = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  _classCallCheck(this, PerformanceMetric);
  /** @type {string} */
  this.metricName = metricName;
  /** @type {number} */
  this.metricValue = metricValue;
  /** @type {number} */
  this.metricQuantity = metricQuantity;
  /** @type {string} */
  this.unitType = unitType;
  /** @type {number} */
  this.payTotal = payTotal;
  /** @type {number} */
  this.absoluteMin = absoluteMin;
  /** @type {number} */
  this.absoluteMax = absoluteMax;
  /** @type {Tier[]} */
  this.tiers = tiers;
});
var Tier = /*#__PURE__*/_createClass(
/**
 * Create a Tier
 * @param {Number} value
 * @param {Number} payAmount
 */
function Tier() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var payAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  _classCallCheck(this, Tier);
  /** @type {Number} */
  this.value = value;
  /** @type {Number} */
  this.payAmount = payAmount;
});
/* eslint-disable no-unused-vars */
/**
 * @function performanceMetricToMetricName
 * PerformanceMetric -> String
 * @param {PerformanceMetric} performanceMetric
 * @returns {String}
 */
var performanceMetricToMetricName = function performanceMetricToMetricName() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    metricName = _ref.metricName;
  return metricName;
};

/**
 * @function performanceMetricToMetricValue
 * PerformanceMetric -> Number
 * @param {PerformanceMetric} performanceMetric
 * @returns {Number}
 */
var performanceMetricToMetricValue = function performanceMetricToMetricValue() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    metricValue = _ref2.metricValue;
  return metricValue;
};

/**
 * @function performanceMetricToMetricQuantity
 * PerformanceMetric -> Number
 * @param {PerformanceMetric} performanceMetric
 * @returns {Number}
 */
var performanceMetricToMetricQuantity = function performanceMetricToMetricQuantity() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    metricQuantity = _ref3.metricQuantity;
  return metricQuantity;
};

/**
 * @function performanceMetricToMetricName
 * PerformanceMetric -> String
 * @param {PerformanceMetric} performanceMetric
 * @returns {String}
 */
var performanceMetricToUnitType = function performanceMetricToUnitType() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    unitType = _ref4.unitType;
  return unitType;
};

/**
 * @function performanceMetricToPayTotal
 * PerformanceMetric -> Number
 * @param {PerformanceMetric} performanceMetric
 * @returns {Number}
 */
var performanceMetricToPayTotal = function performanceMetricToPayTotal() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    payTotal = _ref5.payTotal;
  return payTotal;
};

/**
 * @function performanceMetricToAbsoluteMin
 * PerformanceMetric -> Number
 * @param {PerformanceMetric} performanceMetric
 * @returns {Number}
 */
var performanceMetricToAbsoluteMin = function performanceMetricToAbsoluteMin() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    absoluteMin = _ref6.absoluteMin;
  return absoluteMin;
};

/**
 * @function performanceMetricToAbsoluteMax
 * PerformanceMetric -> Number
 * @param {PerformanceMetric} performanceMetric
 * @returns {Number}
 */
var performanceMetricToAbsoluteMax = function performanceMetricToAbsoluteMax() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    absoluteMax = _ref7.absoluteMax;
  return absoluteMax;
};

/**
 * @function performanceMetricToTiers
 * PerformanceMetric -> Tier[]
 * @param {PerformanceMetric} performanceMetric
 * @returns {Tier[]}
 */
var performanceMetricToTiers = function performanceMetricToTiers() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    tiers = _ref8.tiers;
  return tiers;
};

/**
 * @function tierToValue
 * Tier -> Number
 * @param {Tier} tier
 * @returns {Number}
 */
var tierToValue = function tierToValue() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tier(),
    value = _ref9.value;
  return value;
};

/**
 * @function tierToPayAmount
 * Tier -> Number
 * @param {Tier} tier
 * @returns {Number}
 */
var tierToPayAmount = function tierToPayAmount() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tier(),
    payAmount = _ref10.payAmount;
  return payAmount;
};

/**
 * @function performanceCategoryToName
 * PerformanceCategory -> String
 * @param {PerformanceCategory} performanceCategory
 * @returns {String}
 */
var performanceCategoryToName = function performanceCategoryToName() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    name = _ref11.name;
  return name;
};

/**
 * @function performanceCategoryToCategoryTotalQuantity
 * PerformanceCategory -> Number
 * @param {PerformanceCategory} performanceCategory
 * @returns {Number}
 */
var performanceCategoryToCategoryTotalQuantity = function performanceCategoryToCategoryTotalQuantity() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    categoryTotalQuantity = _ref12.categoryTotalQuantity;
  return categoryTotalQuantity;
};

/**
 * @function performanceCategoryToCategoryTotalUnitType
 * PerformanceCategory -> String
 * @param {PerformanceCategory} performanceCategory
 * @returns {String}
 */
var performanceCategoryToCategoryTotalUnitType = function performanceCategoryToCategoryTotalUnitType() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    categoryTotalUnitType = _ref13.categoryTotalUnitType;
  return categoryTotalUnitType;
};

/**
 * @function performanceCategoryToMetrics
 * PerformanceCategory -> PerformanceMetric[]
 * @param {PerformanceCategory} performanceCategory
 * @returns {PerformanceMetric[]}
 */
var performanceCategoryToMetrics = function performanceCategoryToMetrics() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    metrics = _ref14.metrics;
  return metrics;
};

/**
 * @function payPeriodDataToPayPeriod
 * PayPeriodData -> PayPeriod
 * @param {PayPeriodData} payPeriodData
 * @returns {PayPeriod}
 */
var payPeriodDataToPayPeriod = function payPeriodDataToPayPeriod() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    payPeriod = _ref15.payPeriod;
  return payPeriod;
};

/**
 * @function payPeriodDataToSource
 * PayPeriodData -> String
 * @param {PayPeriodData} payPeriodData
 * @returns {String}
 */
var payPeriodDataToSource = function payPeriodDataToSource() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    source = _ref16.source;
  return source;
};

/**
 * @function payPeriodDataToEarnings
 * PayPeriodData -> String
 * @param {PayPeriodData} payPeriodData
 * @returns {EarningsData}
 */
var payPeriodDataToEarnings = function payPeriodDataToEarnings() {
  var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    earnings = _ref17.earnings;
  return earnings;
};

/**
 * @function payPeriodDataToPerformance
 * PayPeriodData -> PerformanceCategory[]
 * @param {PayPeriodData} payPeriodData
 * @returns {PerformanceCategory[]}
 */
var payPeriodDataToPerformance = function payPeriodDataToPerformance() {
  var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    performance = _ref18.performance;
  return performance;
};

/**
 * @function payViewDataToEmployeeId
 * PayViewData -> String
 * @param {PayViewData} payViewData
 * @returns {String}
 */
var payViewDataToEmployeeId = function payViewDataToEmployeeId() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    employeeId = _ref19.employeeId;
  return employeeId;
};

/**
 * @function payViewDataToEmployeeName
 * PayViewData -> String
 * @param {PayViewData} payViewData
 * @returns {String}
 */
var payViewDataToEmployeeName = function payViewDataToEmployeeName() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    employeeName = _ref20.employeeName;
  return employeeName;
};

/**
 * @function payViewDataToEmployeePayPeriods
 * PayViewData -> PayPeriodData[]
 * @param {PayViewData} payViewData
 * @returns {PayPeriodData[]}
 */
var payViewDataToEmployeePayPeriods = function payViewDataToEmployeePayPeriods() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    employeePayPeriods = _ref21.employeePayPeriods;
  return employeePayPeriods;
};

/**
 * @function payViewDataToTeamMemberPayDatas
 * PayViewData -> TeamMemberPayData[]
 * @param {PayViewData} payViewData
 * @returns {TeamMemberPayData[]}
 */
var payViewDataToTeamMemberPayDatas = function payViewDataToTeamMemberPayDatas() {
  var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    teamMemberPayData = _ref22.teamMemberPayData;
  return teamMemberPayData;
};

/**
 * @function tierAndTierToNumber
 * Tier -> Tier -> Number
 * @param {Tier} tierA
 * @param {Tier} tierB
 * @returns {Number}
 */
var tierAndTierToNumber = function tierAndTierToNumber() {
  var tierA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tier();
  var tierB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Tier();
  return tierToValue(tierA) - tierToValue(tierB);
};

/**
 * @function tiersToAscendingTiers
 * Tier[] -> Tier[]
 * @param {Tier[]} tiers
 * @returns {Tier[]}
 */
var tiersToAscendingTiers = function tiersToAscendingTiers() {
  var tiers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return tiers.sort(tierAndTierToNumber);
};

/**
 * @function performanceMetricToPerformanceMetricWithAscendingTiers
 * PerformanceMetric -> PerformanceMetric
 * @param {PerformanceMetric} performanceMetric
 * @returns {PerformanceMetric}
 */
var performanceMetricToPerformanceMetricWithAscendingTiers = function performanceMetricToPerformanceMetricWithAscendingTiers() {
  var performanceMetric = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric();
  return new PerformanceMetric(performanceMetricToMetricName(performanceMetric), performanceMetricToMetricValue(performanceMetric), performanceMetricToMetricQuantity(performanceMetric), performanceMetricToUnitType(performanceMetric), performanceMetricToPayTotal(performanceMetric), performanceMetricToAbsoluteMin(performanceMetric), performanceMetricToAbsoluteMax(performanceMetric), tiersToAscendingTiers(performanceMetricToTiers(performanceMetric)));
};

/**
 * @function performanceCategoryToPerformanceCategoryWithSortedPerformanceMetrics
 * PerformanceCategory -> PerformanceCategory
 * @param {PerformanceCategory} performanceCategory
 * @returns {PerformanceCategory}
 */
var performanceCategoryToPerformanceCategoryWithSortedPerformanceMetrics = function performanceCategoryToPerformanceCategoryWithSortedPerformanceMetrics() {
  var performanceCategory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory();
  return new PerformanceCategory(performanceCategoryToName(performanceCategory), performanceCategoryToCategoryTotalQuantity(performanceCategory), performanceCategoryToCategoryTotalUnitType(performanceCategory), performanceCategoryToMetrics(performanceCategory).map(performanceMetricToPerformanceMetricWithAscendingTiers));
};

/**
 * @function performanceCategoriesToPerformanceCategoriesWithSortedPerformanceMetrics
 * PerformanceCategory[] -> PerformanceCategory[]
 * @param {PerformanceCategory[]} performanceCategories
 * @returns {PerformanceCategory[]}
 */
var performanceCategoriesToPerformanceCategoriesWithSortedPerformanceMetrics = function performanceCategoriesToPerformanceCategoriesWithSortedPerformanceMetrics() {
  var performanceCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return performanceCategories.map(performanceCategoryToPerformanceCategoryWithSortedPerformanceMetrics);
};

/**
 * @function payPeriodDataToPayPeriodDataWithSortedPerformanceMetrics
 * PayPeriodData -> PayPeriodData
 * @param {PayPeriodData} payPeriodData
 * @returns {PayPeriodData}
 */
var payPeriodDataToPayPeriodDataWithSortedPerformanceMetrics = function payPeriodDataToPayPeriodDataWithSortedPerformanceMetrics() {
  var payPeriodData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData();
  return new PayPeriodData(payPeriodDataToPayPeriod(payPeriodData), payPeriodDataToSource(payPeriodData), payPeriodDataToEarnings(payPeriodData), performanceCategoriesToPerformanceCategoriesWithSortedPerformanceMetrics(payPeriodDataToPerformance(payPeriodData)));
};

/**
 * @function payPeriodDatasToPayPeriodDatasWithSortedPerformanceMetrics
 * PayPeriodData[] -> PayPeriodData[]
 * @param {PayPeriodData[]} payPeriodDatas
 * @returns {PayPeriodData[]}
 */
var payPeriodDatasToPayPeriodDatasWithSortedPerformanceMetrics = function payPeriodDatasToPayPeriodDatasWithSortedPerformanceMetrics() {
  var payPeriodDatas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return payPeriodDatas.map(payPeriodDataToPayPeriodDataWithSortedPerformanceMetrics);
};

/**
 * @function payViewDataToPayViewDataWithSortedPerformanceMetrics
 * PayViewData -> PayViewData
 * @param {PayViewData} payViewData
 * @returns {PayViewData}
 */
var payViewDataToPayViewDataWithSortedPerformanceMetrics = function payViewDataToPayViewDataWithSortedPerformanceMetrics() {
  var payViewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData();
  return new PayViewData(payViewDataToEmployeeId(payViewData), payViewDataToEmployeeName(payViewData), payPeriodDatasToPayPeriodDatasWithSortedPerformanceMetrics(payViewDataToEmployeePayPeriods(payViewData)), payViewDataToTeamMemberPayDatas(payViewData));
};
export { EarningsCategory, EarningsData, MetricEarningsData, PayPeriod, PayPeriodData, PayViewData, PerformanceCategory, PerformanceMetric, TeamMemberPayData, Tier, payPeriodDataToEarnings, payPeriodDataToPayPeriod, payPeriodDataToPayPeriodDataWithSortedPerformanceMetrics, payPeriodDataToPerformance, payPeriodDataToSource, payPeriodDatasToPayPeriodDatasWithSortedPerformanceMetrics, payViewDataToEmployeeId, payViewDataToEmployeeName, payViewDataToEmployeePayPeriods, payViewDataToPayViewDataWithSortedPerformanceMetrics, payViewDataToTeamMemberPayDatas, performanceCategoriesToPerformanceCategoriesWithSortedPerformanceMetrics, performanceCategoryToCategoryTotalQuantity, performanceCategoryToCategoryTotalUnitType, performanceCategoryToMetrics, performanceCategoryToName, performanceMetricToAbsoluteMax, performanceMetricToAbsoluteMin, performanceMetricToMetricName, performanceMetricToMetricQuantity, performanceMetricToMetricValue, performanceMetricToPayTotal, performanceMetricToPerformanceMetricWithAscendingTiers, performanceMetricToTiers, performanceMetricToUnitType, tierToPayAmount, tierToValue };